import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const steam = defineConnector({
  identifier: "steam",
  name: "Steam",
  tagLine: "Gaming platform and storefront",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.steampowered\\.com/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Steam Web API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Steam Web API Key Registration](https://steamcommunity.com/dev/apikey) and register for an API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.steampowered.com/ISteamWebAPIUtil/GetSupportedAPIList/v1/",
  },
});
